import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { TaxExemptModel } from "@SupplyLand/Types/TaxExemptModels";
import { Draft } from "immer";

export type TaxExemptState = Readonly<{
    taxExemptStatus: TaxExemptModel;
}>;

const initialState: TaxExemptState = {
    taxExemptStatus: {} as TaxExemptModel,
};

const taxExemptData = createTypedReducerWithImmer(initialState, {
    "Data/TaxExempt/CompleteLoadTaxExemptStatus": (
        draft: Draft<TaxExemptState>,
        action: { result: TaxExemptModel },
    ) => {
        draft.taxExemptStatus = action.result;
    },
});

export default (reducers as any).taxExemptData = taxExemptData;

export type CustomState = {
    taxExemptData: TaxExemptState;
} & ApplicationState;

type Reducers = {
    taxExemptData: typeof taxExemptData;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
